import React, { useEffect, useState } from 'react';
import { withRouter, Link } from "react-router-dom";
import RolesApi from '../../Services/Roles';
import Alert from '../../Services/Alert';

export const AdminUserList = (props) => {
    const [data, setData] = useState([]);
    const [search, setSearch] = useState('');

    function getUsers() {
        RolesApi.userList({ page: 1, size: 100, search }).then(resp => {
            const r = resp.data;
            if (r.status == 1) setData(r.data.docs);
            else Alert.error(r.message);
        }).catch(e => Alert.error(e.message));
    }

    function onStatus(u) {
        Alert.warning(`${u.status == 1 ? 'Deactivate' : 'Activate'} ${u.email}?`).then(result => {
            if (!result.isConfirmed) return;
            RolesApi.userStatus(u._id).then(res => res.data).then(res => {
                if (res.status) { Alert.success(res.message); getUsers(); }
                else Alert.error(res.message);
            }).catch(e => Alert.error(e.message));
        });
    }

    function onDelete(u) {
        Alert.warning(`Delete ${u.email}? This cannot be undone.`).then(result => {
            if (!result.isConfirmed) return;
            RolesApi.userRemove(u._id).then(res => res.data).then(res => {
                if (res.status) { Alert.success(res.message); getUsers(); }
                else Alert.error(res.message);
            }).catch(e => Alert.error(e.message));
        });
    }

    useEffect(() => { getUsers(); }, []);

    return (
        <section className="main-content marketadd_main_sec">
            <div className="page-content">
                <div className="container-fluid">
                    <div className="row">
                        <div className="col-lg-12">
                            <div className="card">
                                <div className="card-body">
                                    <div className="header-text d-flex justify-content-between align-items-center mb-4">
                                        <h4 className="card-title mb-0">Users &amp; Roles</h4>
                                        <Link to="/admin-users/add" className="btn btn-primary btn-sm">+ Add User</Link>
                                    </div>
                                    <div className="d-flex mb-3" style={{ gap: '8px', maxWidth: '420px' }}>
                                        <input type="text" className="form-control" placeholder="Search name or email"
                                            value={search} onChange={e => setSearch(e.target.value)}
                                            onKeyDown={e => { if (e.key === 'Enter') getUsers(); }} />
                                        <button className="btn btn-outline-primary" onClick={getUsers}>Search</button>
                                    </div>
                                    <div className="table-responsive">
                                        <table className="table align-middle table-nowrap mb-0">
                                            <thead className="table-light">
                                                <tr>
                                                    <th>Name</th>
                                                    <th>Email</th>
                                                    <th>Role</th>
                                                    <th>Status</th>
                                                    <th>Action</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {data && data.length > 0 ? data.map((u, key) => (
                                                    <tr key={key}>
                                                        <td>{[u.firstname, u.lastname].filter(Boolean).join(' ')}</td>
                                                        <td>{u.email}</td>
                                                        <td>
                                                            {u.role === 'admin'
                                                                ? <span className="badge bg-dark">Super Admin</span>
                                                                : (u.role_name || <span className="text-muted">—</span>)}
                                                        </td>
                                                        <td>
                                                            {u.role === 'admin'
                                                                ? <span className="text-muted">—</span>
                                                                : (u.status == 1
                                                                    ? <span className="text-success" style={{ cursor: 'pointer' }} onClick={() => onStatus(u)}>Active</span>
                                                                    : <span className="text-danger" style={{ cursor: 'pointer' }} onClick={() => onStatus(u)}>Inactive</span>)}
                                                        </td>
                                                        <td>
                                                            {u.role === 'admin' ? (
                                                                <span className="text-muted">Super Admin</span>
                                                            ) : (
                                                                <>
                                                                    <Link to={`/admin-users/edit/${u._id}`} className="btn btn-sm btn-outline-primary me-2">Edit</Link>
                                                                    <button className="btn btn-sm btn-outline-danger" onClick={() => onDelete(u)}>Delete</button>
                                                                </>
                                                            )}
                                                        </td>
                                                    </tr>
                                                )) : (
                                                    <tr><td colSpan="5" className="text-center">No users</td></tr>
                                                )}
                                            </tbody>
                                        </table>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
};

export default withRouter(AdminUserList);
